import React, { Component } from 'react'
import gql from 'graphql-tag'
import { graphql } from 'react-apollo'
import Plan from './Plan'

const gqlRegionsAndDepartments = gql`
  {
    regions {
      id
      name
      inseeCode
    }
    departments {
      id
      name
      regionInseeCode
      inseeCode
    }
  }
`

class PlanContainer extends Component {
  getPackedDatas = () => {
    if (
      !this.props.data.loading &&
      this.props.data.regions &&
      this.props.data.departments &&
      this.props.data.regions.length > 0 &&
      this.props.data.departments.length > 0
    ) {
      return this.props.data.regions.map(region => ({
        nameRegion: region.name,
        inseeRegion: region.inseeCode,
        departments: this.props.data.departments.filter(
          dep => dep.regionInseeCode === region.inseeCode
        )
      }))
    } else {
      return null
    }
  }

  render() {
    return (
      <Plan regions={this.getPackedDatas()} loading={this.props.data.loading} />
    )
  }
}

export default graphql(gqlRegionsAndDepartments)(PlanContainer)
